import api from '@/services/api'

export default {
  getAll(params) {
    let queryString = `?page=${params.page || 1}&status=${params.status}`;

    if (params.term) {
      queryString += `&term=${params.term}`;
    }

    if (params.startDate) {
      const startDate = new Date(params.startDate);
      queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
    }

    if (params.endDate) {
      const endDate = new Date(params.endDate);
      queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
    }

    if (params.user) {
      queryString += `&user=${params.user}`;
    }

    return api.get(`/crm${queryString}`);
  },

  create(data) {
    return api.post('/crm', data);
  },

  remove(id) {
    return api.delete('/crm/' + id);
  },

  getSellers() {
    return api.get('/users/sellers');
  },

  getAllActiveSellers() {
    return api.get('/users/sellers/active');
  },

  export(params) {
    let queryString = `?export=true&status=${params.status}`;

    if (params.term) {
      queryString += `&term=${params.term}`;
    }

    if (params.startDate) {
      const startDate = new Date(params.startDate);
      queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
    }

    if (params.endDate) {
      const endDate = new Date(params.endDate);
      queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
    }

    if (params.user) {
      queryString += `&user=${params.user}`;
    }

    return api({
      url: `/crm${queryString}`,
      method: 'GET',
      responseType: 'blob',
    })
  },
}